module.exports = __webpack_public_path__ + "static/img/ProductQuality.85ea0019.png";